/**
 * Syncs Amplitude device ID to cart attributes.
 */

import { setCartAttributes, waitForAmplitude } from "@theme/utilities";

const namespace = "[AmplitudeDeviceIdCart]";
const ATTRIBUTE_KEY = "_amplitude_device_id";

/**
 * @param {string | null | undefined} raw
 * @returns {string | null}
 */
function parseCartAttributeFromDataset(raw) {
  if (raw === undefined || raw === "" || raw === "null") {
    return null;
  }
  return raw;
}

/**
 * @returns {Promise<string | null>}
 */
async function waitForAmplitudeDeviceId() {
  try {
    await waitForAmplitude();

    if (typeof window.amplitude?.getDeviceId === "function") {
      const id = window.amplitude.getDeviceId();
      if (id) {
        return id;
      }
    }
    return null;
  } catch {
    console.warn(`${namespace} - Amplitude SDK not available`);
    return null;
  }
}

async function syncAmplitudeDeviceIdToCart() {
  const scriptEl = document.querySelector("script[data-amplitude-device-id]");
  const raw = scriptEl instanceof HTMLScriptElement ? scriptEl.dataset.amplitudeDeviceId : null;
  const existingCartDeviceId = parseCartAttributeFromDataset(raw);

  const deviceId = await waitForAmplitudeDeviceId();

  if (!deviceId) {
    console.log(`${namespace} - No device ID found, skipping update`);
    return;
  }

  if (deviceId === existingCartDeviceId) {
    console.log(`${namespace} - Device ID is already set on cart, skipping update`);
    return;
  }

  try {
    console.log(`${namespace} - Updating cart attribute with new Device ID: ${deviceId}`);
    await setCartAttributes({ [ATTRIBUTE_KEY]: deviceId });
  } catch (error) {
    console.error(`${namespace} - Failed to update cart attribute`, error);
  }
}

syncAmplitudeDeviceIdToCart();
